import config from '../config/config';

let isLoading = false;
let isLoaded = false;
let loadError = null;
const callbacks = [];

export const loadGoogleMaps = () => {
  return new Promise((resolve, reject) => {
    // If already loaded, resolve immediately
    if (isLoaded && window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    // If there was an error, reject immediately
    if (loadError) {
      reject(loadError);
      return;
    }

    // Add callback to queue
    callbacks.push({ resolve, reject });

    // If already loading, just wait
    if (isLoading) {
      return;
    }

    // Start loading
    isLoading = true;

    try {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAPS_API_KEY}&libraries=places,drawing&v=weekly`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        isLoaded = true;
        isLoading = false;
        
        // Resolve all waiting callbacks
        callbacks.forEach(cb => cb.resolve(window.google.maps));
        callbacks.length = 0;
      };

      script.onerror = (error) => {
        isLoading = false;
        loadError = new Error('Failed to load Google Maps');
        
        // Reject all waiting callbacks
        callbacks.forEach(cb => cb.reject(loadError));
        callbacks.length = 0;
      };

      document.head.appendChild(script);
    } catch (error) {
      isLoading = false;
      loadError = error;
      
      // Reject all waiting callbacks
      callbacks.forEach(cb => cb.reject(error));
      callbacks.length = 0;
    }
  });
};

export const isGoogleMapsLoaded = () => {
  return isLoaded && window.google && window.google.maps;
};
